import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, RequestMethod } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { HttpInterceptor } from '../common/interceptor/http-interceptor';

@Injectable()
export class ClientService {

    constructor(private http: Http, private customHttp: HttpInterceptor) {}

    /**
     * 헤더 설정
     */
    getHeadersFromSession() {
      const headers = new Headers({'authorization' : 'bearer ' + sessionStorage.getItem('access_token')});
      return headers;
    }

    /**
     * client 리스트 가져오기
     */
    getClients(page, size) {
      return this.customHttp.get(environment.userClientUrl + '/clients?page=' + page + '&size=' + size);
    }

    /**
     * client 상세 조회
     */
    getClient(clientId) {
      return this.customHttp.get(environment.userClientUrl + '/clients/' + clientId);
    }

    /**
     * 클라이언트 등록
     * @param client
     ***/
    createClient(client) {
      return this.customHttp.post(environment.userClientUrl + '/clients', client);
    }

    /**
     * 클라이언트 수정
     * @param client
     */
    modifyClient(client, clientId) {
      return this.customHttp.put(environment.userClientUrl + '/clients/' + clientId, client);
    }

    /**
     * 클라이언트 삭제;
     */
    removeClient(clientId) {
      return this.customHttp.delete(environment.userClientUrl + '/clients/' + clientId);
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/client/client.service.ts